/**
 * Keep the cart page and the cart drawer showing the same cart.
 *
 * On /cart both surfaces are on the page at once, and each one re-renders only
 * its own sections after a /cart/change. Remove a line on the page and the
 * drawer keeps the row it already had, still carrying the old line index; the
 * next click on that row asks the server for a line that no longer exists and
 * comes back "O parametro line e invalido", with nothing removed and no price
 * update. The reverse happens too.
 *
 * The theme publishes cart-update after every successful cart mutation, so
 * redraw both surfaces from one sections request whenever that fires. Pages
 * that only carry the drawer are left alone - the theme keeps those in step by
 * itself, and there is nothing there to disagree with.
 */
(function () {
  var CART_UPDATE = 'cart-update'; // PUB_SUB_EVENTS.cartUpdate, which is not exported
  var inFlight = false;
  var again = false;

  function sectionInnerHTML(html, selector) {
    var found = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return found ? found.innerHTML : null;
  }

  function replaceContents(host, html) {
    if (!host || !html) return;
    var target = host.querySelector('.js-contents');
    var markup = sectionInnerHTML(html, '.js-contents');
    if (target && markup !== null) target.innerHTML = markup;
  }

  /**
   * renderContents carries the toggles' old on/off state into the fresh markup,
   * which is what you want when the drawer did the toggling itself and wrong
   * when the cart page removed the line behind its back - the switch stays on
   * over a charger that is no longer in the cart, and the next click on it does
   * nothing visible. The cart is the truth. Gifts are left alone: the theme adds
   * and removes those itself off the same attribute.
   */
  function matchTogglesToCart(drawer) {
    drawer.querySelectorAll('cart-drawer-upsell[data-toggle="true"]').forEach(function (upsell) {
      var handle = upsell.dataset.handle;
      if (!handle) return;
      upsell.dataset.selected = drawer.querySelector('.cart-item--product-' + handle) ? 'true' : 'false';
    });
  }

  function resync() {
    var drawer = document.querySelector('cart-drawer');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');

    // Only the cart page holds both surfaces, and only there can they disagree.
    if (!drawer || !items) return;

    if (inFlight) {
      again = true;
      return;
    }
    inFlight = true;

    var ids = ['cart-drawer', 'cart-icon-bubble', items.dataset.id];
    if (footer) ids.push(footer.dataset.id);

    fetch(location.pathname + '?sections=' + ids.join(','))
      .then(function (response) {
        if (!response.ok) throw new Error('sections request failed');
        return response.json();
      })
      .then(function (sections) {
        // The second argument keeps renderContents from opening the drawer -
        // without it, removing a line on the cart page makes it fly open.
        if (typeof drawer.renderContents === 'function' && sections['cart-drawer']) {
          drawer.renderContents({ sections: sections }, true);
          matchTogglesToCart(drawer);
        }
        replaceContents(items, sections[items.dataset.id]);
        if (footer) replaceContents(footer, sections[footer.dataset.id]);
      })
      .catch(function () {
        /* leave both surfaces as the theme left them */
      })
      .finally(function () {
        inFlight = false;
        // A second cart change landed while this one was in the air.
        if (again) {
          again = false;
          resync();
        }
      });
  }

  /**
   * Removing the last line from the cart page sends the theme looking for the
   * drawer's empty state to move focus into. That block is only in the markup
   * when the drawer was rendered empty, so on a cart that had items it is null,
   * trapFocus throws, and the throw lands in the cart's catch: it writes "Ocorreu
   * um erro ao atualizar o seu carrinho" under a cart that emptied perfectly well,
   * and it swallows the cart-update the resync above listens for. Nothing to trap
   * focus in is not an error, so treat it as one less thing to do.
   */
  function guardTrapFocus() {
    var original = window.trapFocus;
    if (typeof original !== 'function') return;

    window.trapFocus = function (container) {
      if (!container) return;
      return original.apply(this, arguments);
    };
  }

  if (typeof window.subscribe === 'function') window.subscribe(CART_UPDATE, resync);
  guardTrapFocus();
})();
